"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _colors = require("HubStyleTokens/colors");

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

function _default(props) {
  return _react.default.createElement(_UIIcon.default, (0, _extends2.default)({
    color: _colors.EERIE
  }, props, {
    name: "pdfFile"
  }));
}

module.exports = exports.default;